import {
  ChannelCreatorActions,
  ChannelCreatorGetters,
  ChannelCreatorMutations,
  ChannelCreatorState
} from "@medapro-types/ChannelCreator/store/channel-creator-store";
import { createNamespacedHelpers } from "vuex-composition-helpers";

const { useState, useGetters, useMutations, useActions } = createNamespacedHelpers<
  ChannelCreatorState,
  ChannelCreatorGetters,
  ChannelCreatorActions,
  ChannelCreatorMutations
>("channelCreator");

export const useChannelCreatorState = () => {
  return useState([
    "selectedAttributeGroup",
    "fieldMappings",
    "isLoading",
    "selectedMappingProjectId",
    "catalogs",
    "modified",
    "mappingTargets",
    "targetAbortController"
  ]);
};
export const useChannelCreatorGetters = () => {
  return useGetters([
    "isSaving",
    "hasUnsavedData",
    "getSelastRunSuccesslectedMappingProjectId",
    "isBaseMappingTabBusy",
    "selectedTargetCatalog",
    "selectedMappingProject"
  ]);
};
export const useChannelCreatorMutations = () => {
  return useMutations([
    "reset-state",
    "add-running-promise",
    "reset-running-promises",
    "set-is-source-fields-tree-busy",
    "set-is-target-mapping-tree-busy",
    "setMappingTargets",
    "setCatalogs",
    "addCatalog",
    "renameCatalog",
    "deleteCatalog",
    "updateTargetCatalog",
    "markDirty",
    "clearDirtyStatus",
    "setIsSourceCatalogStructureLoaded",
    "setIsTargetCatalogStructureLoaded",
    "updateSaveStatus",
    "resetUpdateStatus",
    "setNotificationSeen",
    "sourceCatalogSearchResults",
    "targetCatalogSearchResults",
    "changeCurrentSourceCatalogSearchResult",
    "changeCurrentTargetCatalogSearchResult",
    "clearAllSearch",
    "updateTargetFieldMappings",
    "updateFieldMappings",
    "deleteCurrentMapping",
    "reset-ToBeDeletedFieldMappingMap",
    "addCurrentFieldMapping",
    "updateFieldMappingExpression",
    "loadAttributeGroups",
    "loadMappingProjects",
    "addMappingProject",
    "updateSelectedMappingProjectId",
    "updateSelectedAttributeGroup",
    "deleteMappingProject",
    "updateMappingProjectName",
    "setShouldReloadSourceFieldLocalizations",
    "setSourceAbortController",
    "setTargetAbortController"
  ]);
};
export const useChannelCreatorActions = () => {
  return useActions([
    "resetRunningPromisesIfResolved",
    "addRunningPromise",
    "setIsSourceFieldsTreeBusy",
    "setIsTargetMappingTreeBusy",
    "loadMappingTargets",
    "loadCatalogs",
    "addCatalog",
    "renameCatalog",
    "removeCatalog",
    "updateTargetCatalog",
    "saveCatalogDetails",
    "searchSourceCatalog",
    "searchTargetCatalog",
    "loadTargetFieldMappings",
    "cancelSourceActionsIfAny",
    "cancelTargetActionsIfAny",
    "loadFieldMappings",
    "createFieldMapping",
    "updateFieldMapping",
    "deleteFieldMappings",
    "deleteAllFieldMappings",
    "saveFieldMapping",
    "loadAttributeGroupsOfCatalog",
    "loadMappingProjectsOfCatalog",
    "updateSelectedMappingProjectId",
    "updateSelectedAttributeGroup",
    "addMappingProject",
    "copyMappingProject",
    "deleteMappingProject",
    "updateMappingProjectName"
  ]);
};
